import Controller from '@ember/controller';

class AdminAccountingAccountsAgingController extends Controller {
  responsiveTableCallback(_, index) {
    return index !== 0;
  }
}

export default AdminAccountingAccountsAgingController;
